import {
    Box,
    Button,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SmartCaptcha from './SmartCaptcha';
import AuthTextField from './AuthTextField';
import { AUTH_FIELD_LIMITS, getLoginFieldHint } from './authValidation';
import { authErrorSx, authPrimaryButtonSx } from './authDialogStyles';

const LoginTab = ({ onSubmit, loading, apiError, onClearApiError, captchaEnabled = true }) => {
    const { t } = useTranslation();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [captchaToken, setCaptchaToken] = useState('');
    const [captchaResetKey, setCaptchaResetKey] = useState(0);
    const [fieldError, setFieldError] = useState('');
    const [loginTouched, setLoginTouched] = useState(false);

    const loginHint = getLoginFieldHint(login, loginTouched);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setFieldError('');

        if (!captchaToken) {
            setFieldError(t('Подтвердите, что вы не робот'));
            return;
        }

        try {
            await onSubmit({ login, password, captcha_token: captchaToken });
        } catch {
            setCaptchaToken('');
            setCaptchaResetKey((value) => value + 1);
        }
    };

    const isFormValid = login.trim().length >= AUTH_FIELD_LIMITS.loginMinLength
        && login.trim().length <= AUTH_FIELD_LIMITS.loginMaxLength
        && password.length >= 1
        && Boolean(captchaToken);

    const displayError = fieldError || apiError?.message;

    return (
        <Box
            component='form'
            onSubmit={handleSubmit}
            sx={{ display: 'flex', flexDirection: 'column', gap: '16px', alignSelf: 'stretch' }}
        >
            <AuthTextField
                label={t('Логин')}
                value={login}
                onChange={(e) => {
                    setLogin(e.target.value);
                    onClearApiError?.();
                }}
                onBlur={() => setLoginTouched(true)}
                error={Boolean(loginHint) || Boolean(apiError?.fields?.login)}
                helperText={loginHint ? t(loginHint) : undefined}
                required
                autoComplete='username'
                placeholder={t('Введите логин')}
            />
            <AuthTextField
                label={t('Пароль')}
                type='password'
                value={password}
                onChange={(e) => {
                    setPassword(e.target.value);
                    onClearApiError?.();
                }}
                error={Boolean(apiError?.fields?.password)}
                required
                autoComplete='current-password'
                placeholder={t('Введите пароль')}
            />
            <SmartCaptcha
                enabled={captchaEnabled}
                resetKey={captchaResetKey}
                onToken={setCaptchaToken}
            />
            {displayError && (
                <Typography sx={authErrorSx}>
                    {displayError}
                </Typography>
            )}
            <Box sx={{ pt: '4px' }}>
                <Button type='submit' variant='contained' disabled={loading || !isFormValid} sx={authPrimaryButtonSx}>
                    {t('Войти')}
                </Button>
            </Box>
        </Box>
    );
};

export default LoginTab;
